<div class="edit-page">

  <div class="visitor">

    <button class="close" (click)="close()">
      <img
        class="cross-icon"
        src="icons/profile-close.svg"
      />
    </button>

    <span class="visitor-txt">
      Change Status
    </span>

  </div>

  <p class="form-header">
    Are you sure you want to change the status of the user to
    <b>{{ data.status }}</b> ?
  </p>

  <div class="action-row">

    <button
      class="ac-secondary-btn"
      (click)="close()"
    >
      Cancel
    </button>

    <button
      class="primary-btn"
      (click)="continue()"
    >
      Yes
    </button>

  </div>

</div>